module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ALOS")]), _vm._v(" X"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENAKIS")])]), _vm._v(" had heard a lot of lies in his life, particularly in relation to his beautiful, ruthless ex-mistress. But this one topped them all.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It can’t be true,” he said in shock, staring at the doctor. “She’s lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I assure you, Mr. Xenakis, it’s true,” Dr. Bartlett replied gravely. “She has no memory. Not of you, not of me, not even of her accident yesterday. And yet there’s no physical injury.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Because she’s lying!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She was wearing a seat belt when her head hit the air bag,” Dr. Bartlett continued. “There was no concussion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos stared at him with a scowl. He had a reputation as a doctor of immense skill and integrity. He was rich from a lifetime of serving wealthy, aristocratic patients—so he couldn’t be bought. He was known as a family man, still completely in love with his wife of fifty years, an adored father of three and grandfather of eight—so he couldn’t be seduced. So he honestly must believe Eve Craig had amnesia.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Amnesia.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos’s lip curled. After all of her devilish cleverness, he would have expected more of her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Eleven weeks ago, after stabbing him in the back, Eve Craig had vanished from Athens like a ghost. His men had searched for her all over the world without success until two days ago, when she’d suddenly resurfaced in London for her stepfather’s funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos had dropped a billion-dollar deal in Sydney, ordering his men to trail her until he could reach London on his private jet. Kefalas and Leonidas had been right behind Eve yesterday afternoon when she’d left the private hospital in Harley Street. They’d watched her tuck her long, glossy dark hair beneath a silk scarf, put on big black sunglasses and white driving gloves and drive away in her silver Aston Martin convertible.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Right into a red postbox on the sidewalk.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It was so strange, boss,” Kefalas had told him that morning when he’d arrived from Sydney. “She seemed fine at the funeral. But leaving the doctor’s office she drove like a drunk. She didn’t even recognize us when we helped her back into the hospital after the accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Now, Dr. Bartlett looked equally puzzled as he scratched the back of his wispy white head. “I held her overnight for observation, but cannot find anything physically wrong with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos ground his teeth. “Because she doesn’t have amnesia. She’s playing you for a fool!”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("The elderly doctor stiffened. “I do not believe Miss ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Craig is lying, Mr. Xenakis. I have known her since she was fourteen, when she first came here with her mother from America.” He shook his head as he mused, “All the tests came back negative. The only symptom seems to be the amnesia. Leading me to perhaps wonder if the accident was merely the catalyst—the trauma was an emotional one.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“You mean she brought it on herself?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I wouldn’t say that exactly. But this is outside my field. It’s why I’ve recommended a colleague, Dr. Green.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A psychiatrist.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos latched on to the one valuable bit of information. “So if there’s nothing physically wrong with her, she can leave the hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The doctor hesitated. “She’s certainly strong enough. But as she has no memory, perhaps it would be better if a member of her family…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She has no family,” Talos interrupted. “Her stepfather was her only relative, and he died three days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I did hear about Mr. Craig, and was very sorry. But I hoped perhaps Eve might have an aunt or uncle, or even a cousin in Boston…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She does not,” Talos said evenly, although he had no idea. He only knew nothing was going to keep him from taking Eve away with him today. “I am her…” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What? Ex-lover bent on revenge?")]), _vm._v(" “Boyfriend,” he finished smoothly. “I will take care of her.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("“So your men told me yesterday, when they said you were on your way.” Dr. Bartlett eyed him as if he did ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("not quite like what he saw. “But it does not sound as if you even believe she needs special care.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“If you say she has amnesia, I have no choice but to believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You called her a liar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos gave a crooked grin. “Creative untruths are part of her charm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So you are close?” The doctor looked up at him with narrowed eyes. “Do you plan to marry her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos knew the answer the man wanted—the only answer that would release Eve into his power. And so he told the truth. “She is everything to me. Everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Scrutinizing Talos’s expression, the doctor stroked his beard with something like satisfaction, then nodded in a sudden brisk decision. “Very well. I’ll release her into your care, Mr. Xenakis. Take good care of her. Take her home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Take her to Mithridos? Talos would die before he would pollute his home that way. But Athens…yes. He’d lock her up and make her thoroughly regret betraying him. “You will release her to me today?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The doctor nodded. “Yes. Make her feel loved,” he warned. “Make her feel wanted and secure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Loved and secure,” he repeated, barely able to keep the sneer from his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dr. Bartlett frowned. “Surely, Mr. Xenakis, you can appreciate what these last twenty-four hours have meant to Eve. She’s had nothing to cling to. No memory of family or friends to sustain her. No sense of home or memory of belonging. She didn’t even know her name until I told her.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Don’t worry,” Talos said grimly. “I’ll take good care of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But as he started to turn away, the doctor stopped him. “There is something else you should know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Normally I would never disclose this information. But in this unique case, I feel the need for informed care far exceeds the concern for privacy….”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With a muttered curse in Greek, Talos tapped his foot impatiently. “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Eve is pregnant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At that word, Talos’s head shot up. His heart literally stopped in his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Pregnant?” he choked. “When?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When I did the ultrasound yesterday, I estimated conception in mid-June.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("June.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For nearly all of that month Talos had barely left her side. He’d kept tabs on his business almost unwillingly, begrudging every moment of his life that wasn’t spent in bed with her. Their affair had burned him through, blood and bone. He’d thought—God help him—that he could trust her. Because lust had seized his mind and will.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I feel I’m at fault,” Dr. Bartlett continued regretfully. “If I’d had any idea how upset she was at the news of her pregnancy, I would never have let her drive away from the hospital. But don’t worry,” he added hastily, “your baby is fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("His")]), _vm._v(" baby.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Talos stared at him, hardly able to breathe.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The doctor suddenly gave a hearty, cheerful laugh, patting him on the back. “Congratulations, Mr. Xenakis. You’re going to be a father.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Around her, Eve was dimly aware of a whisper of voices and the distant hum of a radiator. She felt someone—the nurse?—sweep a cool cloth against her forehead. The soft sheets against her skin felt heavy. She smelled the fresh scent of rain and cotton. But she stubbornly kept her eyes closed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t want to wake up. She didn’t want to leave the dark peacefulness of sleep, the warmth of barely remembered dreams that still cradled her like an embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She didn’t want to return to the nothingness of existence, where she had no memories. No identity. Nothing to cling to. It was an emptiness far worse than any pain.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And then the doctor had told her three hours ago that she was pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She couldn’t remember conceiving the child. Couldn’t even remember the face of her baby’s father. But she would meet him today. He would be here any minute.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Covering her head with her pillow, she squeezed her eyes shut. She was racked with nervousness and fear at the thought of meeting him for the first time—the father of her unborn baby!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What kind of man would he be?")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("She heard the door open and close. She held her breath. Then someone sat heavily next to her, causing her ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("body to lean toward him on the mattress. Strong arms suddenly were around her. She felt the warmth of a man’s body, breathed in the woodsy musk of his cologne.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Eve, I’m here.” The man’s voice was deep and low, with an exotic accent she couldn’t place. “I’ve come for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A thrill rushed through her. With an intake of breath, she pushed aside the pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was so close to her. She saw the sharpness of his cheekbones first. The dark scruff on his hard jaw. The tawny color of his olive skin. Then, as he drew back, she saw his whole face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was, quite simply, breathtaking.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("How was it possible for a man to be at once so masculine—and so beautiful? His black hair brushed the top of his ears. He had the face of an angel. Of a warrior. His Roman nose had been broken at least once, from the tiny imperfection of the angle. He had a full, sensual mouth, with a twist of his lips that revealed arrogance and perhaps more—cruelty?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His eyes gleamed down at her, dark as night. And beneath their black depths, for a moment she saw a ravaging fire of hatred—as if he wished she were dead, as if she were a ghost he’d long ago consigned to hell.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then she blinked, and he was smiling down at her with tender concern.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She must have imagined that fiery hatred, she thought in bewilderment. Not surprising considering how screwy her head had been since the accident—an accident she couldn’t even remember!")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Eve,” he whispered as he stroked her cheek. “I thought I’d never find you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The touch of his rough fingers against her skin burned her. She felt a sizzle down her neck to her breasts, making her nipples taut and her belly spiral in a strange tightness. With an intake of breath, she searched his face, hardly able to believe the evidence of her own eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This—this man was her lover? He looked nothing like she’d expected.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When Dr. Bartlett had told her that her boyfriend was on his way from Australia, she’d imagined a kind-looking man with a loving heart, a sense of humor. A gentle man who would share his troubles while they washed dishes together at the end of the day. She’d dreamed of a loving partner. An equal.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Never in her wildest dreams had she ever imagined a dark god like this, cruelly beautiful, masculine and so powerful that he could no doubt slice her heart in two with a look.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Aren’t you glad to see me?” he said in a low voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She searched his face, holding her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But no memories rushed through her, no recollections of the hard curve of his cheek or the slightly wicked twist to his sensual lips. No memories of a thousand little intimacies between lovers. Nothing!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He helped her sit up. His hands lingered possessively on her back, causing a sudden heat across her body.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Eve licked her lips nervously.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“You are…you must be…Talos Xenakis?” she ven")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("tured, waiting for him to deny it. Almost hoping he would, and that her real boyfriend, the kind-faced man with the gentle eyes, would walk through the door.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The Greek tycoon’s hands on her back paused.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So you do recognize me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She shook her head. “No. Your two employees…the doctor…they told me your name. They said you were on your way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He looked down at her, searching her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dr. Bartlett told me you had amnesia. I didn’t believe it. But it’s true, isn’t it? You really don’t remember me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She could only imagine how that must hurt him! “I’m sorry,” she said, rubbing her forehead. “I keep trying, but the first thing I can remember is your employee—Kefalas?—pulling me from my car. It was a lucky thing they were in the car behind me!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His lips seemed to curve imperceptibly. “Yes. Very lucky.” He sat up straight. “You will be leaving the hospital today.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She took a deep breath. “Today?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But…” She bit her lip then blurted out, “But I still can’t remember anything! I hoped when I saw you…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You hoped seeing me would bring your memory back?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She nodded miserably. There was no point in feeling disappointed, she told herself fiercely, or making him feel more badly about it than he must already!")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("But she couldn’t stop the lump in her throat. She’d been ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("counting on the idea that when she saw the face of the man she loved, the man who loved her, her amnesia would end.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Unless they didn’t love each other, she thought suddenly. Unless she’d gotten pregnant by a man who was barely more than a one-night stand.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m sure you must feel so hurt,” she said, trying to push away her sudden fear. She said haltingly, “I can only imagine how it must feel, to love someone who can’t remember you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do you love me?")]), _vm._v(" she thought desperately, trying to read his face. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Do I love you?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Shhh. It’s all right.” Lowering his head, he kissed her tenderly on the forehead. The warmth of his nearness was like the summer sun on a winter’s day. Then he lifted her chin, and his dark eyes whipped through her like a blast of heat. “Don’t worry, Eve. In time, you will remember—everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Looking into his face gratefully, Eve realized that her first impression of him had been utterly wrong. He wasn’t cruel. He was kind. How else to explain the fact that he could be so gentle and patient and loving, pushing aside his own hurt to focus only on her?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She took a deep breath. She would be as brave as he was. Pushing the blankets aside, she said over the lump in her throat, “I’ll get dressed to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He stopped her. “Wait. There’s something else we need to talk about.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("She knew instantly what he meant to discuss. And without the barrier of blankets between them, in just her paper-thin hospital gown, she felt painfully bare, vul")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("nerable in every way. She yanked the blankets back over her body, tugging them halfway to her neck.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“He told you, didn’t he?” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His voice was low, almost grim. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Are you happy?” Her voice trembled. “About the news?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She held her breath as his darkly handsome face stared down at her. When he finally spoke, his voice was charged with some emotion she didn’t recognize.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I was surprised.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She searched his gaze. “So the baby wasn’t something we planned?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His hands tightened, twisting the blanket in his grip. He glanced down at it, then looked at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve never seen you like this,” he said in a low voice. His black gaze hungrily caressed her face. With his fingertips, he brushed some dark tendrils from her cheek. “No makeup. Bare.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She tried to pull away. “I’m sure I look terrible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But he drew her closer. His eyes were dark as he looked down at her, making her shiver from deep within.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Are you happy about the baby?” she said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He put his arms around her. “I’m going to take good care of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Why wouldn’t he answer? She swallowed, then lifted her head to give him a weak smile. “Don’t worry, I’m not an invalid. I hope the amnesia will disappear in a day or two. Dr. Bartlett said something about a specialist—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His arms tightened around her, cradling her against his hard chest.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“You don’t need another doctor,” he said roughly. “You just need to come home with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She could feel the beat of his heart against her cheek through his black button-down shirt. She was enveloped in his masculine scent, sandalwood and amber, exotic and woodsy. Against her will, she closed her eyes. She breathed in his smell, heard the beat of his heart, felt his warmth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Everything else faded. The private hospital room, the nurses and doctor visible through the window of the door, the sound of one of Talos’s men speaking urgently into his cell phone in some language she didn’t recognize, the antiseptic smell, the beeps of the machines…it all faded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was only this.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Only him.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Held securely in his strong arms, for the first time since her accident she felt safe and loved. She felt as if she had a place in the world. With him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He kissed her hair softly. She felt the warmth of his breath, the hot caress of his lips, and a tremble went over her. Fear? Longing?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Did he love her?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She reached upward, cupping his rough jawline with her hands. Though his clothes were sharply pressed, the dark shadow on his chin suggested he’d changed clothes on the plane without bothering to shave. He’d rushed here from Australia. He’d flown all night.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Did that mean love?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why didn’t you come to London with me for my stepfather’s funeral?” she said slowly.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("He paused. When he spoke, he seemed to choose his words with care.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I was busy in Sydney acquiring a new company. Believe me,” he said, “I never wanted to be away from you for this long.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Eve felt there was something he wasn’t telling her. Or was that just her own confusion playing tricks on her? She couldn’t trust anything in this hazy, empty world, not even her own mind! “But why—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You are so beautiful, Eve,” he said, cupping her face. He exhaled in a rush. “I almost feared I’d never see your face again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When you heard about the accident, you mean? You were worried about me?” she said in a small voice. When he didn’t answer, she licked her lips. With a deep breath, she asked the question that had been burning through her. “Because we love each other?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His jaw clenched as he took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You were a virgin when I seduced you, Eve,” he said in a low voice. “You’d never been with any man before I took you to my bed three months ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She’d been a virgin?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A wave of relief washed over her. Learning she was pregnant by a boyfriend she couldn’t remember had been a tremendous shock. She’d wondered why they weren’t married—wondered all sorts of things. But if Talos had been her one and only lover, if she’d been a virgin at twenty-five, surely that said something about her character?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But did it also mean love?")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She looked up into his handsome face, opening her mouth to ask again, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Do I love you? Do you love me?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then she stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was something beneath his darkly penetrating eyes. Something he wasn’t saying. Something hidden beneath his words.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But before she could understand what her intuition was telling her, Talos placed his broad hands over hers. The warmth of his fingers burned her, intertwined with her own. Trapping her, but not against her will. Her heart pounded faster.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Get ready to leave.” He lowered his head to kiss her on the temple, running his hands up and down her bare forearms. “I want to take you home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her breathing became short and shallow as he touched her skin. Little prickles of sensation sped up her arms, down her back, making her hair stand on end. The tingle swirled across her earlobes, down her neck, making her naked breasts beneath her thin hospital gown suddenly feel tight and full. She tried to remember the question she’d been asking, but it had already swept from her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right,” she breathed, looking up into his handsome face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gallantly, he helped her from the bed, lifting her gently to her feet. She was more aware than ever of how much taller he was, how much more powerful. He was at least six inches taller, with an extra hundred pounds of pure muscle. Looking up at him, she forgot everything but her own longing and fascinated desire for the man towering over her like a dark angel.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m sorry it took so long for me to reach you, Eve,” he said in a low voice. “But I’m here now.” He kissed her head softly, his arms tightening around her as he pulled her into an embrace. “And I’m never going to let you go.”")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20be1066","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/boughtthegreeksbaby_ch01.vue
// module id = 75
// module chunks = 0